(function($) {
    
    // Forms
    function hoyry_init_form() {
        
        setTimeout(function() {
            if( $('.hoyry-form, .fluentform').length ) {
                
                // Reset Fluentform button
                $('.hoyry-form, .fluentform').find('.ff-btn:not(.ff-btn-submit)')
                    .addClass('wp-element-button')
                    .addClass('wp-block-button__link')
                    .addClass('hoyry-form-button')
                    .removeClass('ff_btn_style')
                    .removeClass('ff-btn')
                    .removeClass('ff-btn-md')
                    .removeClass('ff_upload_btn')
                    .wrap('<div class="wp-block-button"></div>');
                
                // Reset Fluentform submit button
                $('.hoyry-form, .fluentform').find('.ff-btn-submit')
                    .addClass('wp-element-button')
                    .addClass('wp-block-button__link')
                    .addClass('hoyry-form-submit-button')
                    .removeClass('ff_btn_style')
                    .removeClass('ff-btn-submit')
                    .removeClass('ff-btn')
                    .removeClass('ff-btn-md')
                    .removeClass('ff_upload_btn')
                    .wrap('<div class="wp-block-button"></div>');
                
                // Add hoyry-form-select wrapper to all select fields
                $('.hoyry-form, .fluentform').find('select:not(.ff_has_multi_select):not([class*="flatpickr"])').each(function() {
                    if( !$(this).parent().hasClass('hoyry-form-select') ) {
                        $(this).wrap('<div class="hoyry-form-select"></div>');
                    }
                });
                
                // Add hoyry-form-control class to fields
                $('.hoyry-form, .fluentform').find('input[type="text"]:not(.choices__input), input[type="password"], input[type="color"], input[type="date"], input[type="datetime"], input[type="datetime-local"], input[type="email"], input[type="month"], input[type="number"], input[type="search"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], select:not([class*="flatpickr"]), textarea').addClass('hoyry-form-control');
                
                // Add hoyry-form-radio element after all radio fields
                $('.hoyry-form, .fluentform').find('input[type="radio"]').each(function() {
                    if( !$(this).hasClass('hoyry-form-radio-input') ) {
                        $(this).addClass('hoyry-form-radio-input');
                        if( $(this).closest('.ff-el-image-holder').length == 0 ) $(this).after('<span class="hoyry-form-radio"></span>');
                    }
                });
                
                // Add hoyry-form-checkbox element after all checkbox fields
                $('.hoyry-form, .fluentform').find('input[type="checkbox"]').each(function() {
                    if( !$(this).hasClass('hoyry-form-checkbox-input') ) {
                        $(this).addClass('hoyry-form-checkbox-input');
                        if( $(this).closest('.ff-el-image-holder').length == 0 ) $(this).after('<span class="hoyry-form-checkbox"></span>');
                    }
                });
                
                // Set is-placeholder-selected class to select fields when value is empty
                $('.hoyry-form, .fluentform').find('select:not(.ff_has_multi_select):not([class*="flatpickr"])').each(function() {
                    if( !$(this).val() || $(this).val() == null ) $(this).closest('.hoyry-form-select').addClass('is-placeholder-selected');
                });
                $(document).on('change', '.hoyry-form select:not([class*="flatpickr"]), .fluentform select:not(.ff_has_multi_select):not([class*="flatpickr"])', function() {
                    if( !$(this).val() ) $(this).closest('.hoyry-form-select').addClass('is-placeholder-selected');
                    else $(this).closest('.hoyry-form-select').removeClass('is-placeholder-selected');
                });
                
            }
        }, 100);
        
    }
    
	$(document).ready(function() {
        hoyry_init_form();
    });
    
    // Navigation
    $('.wp-block-navigation__container:not(.is-menu-open *) > .has-child').on('mouseenter', function() {
        
        var $submenu = $(this).find('> .wp-block-navigation__submenu-container');
        var $parent = $(this);
        $submenu.css('left', '0');
        
        setTimeout(function() {
            
            var newLeft = 0;
            var dimensions = $submenu[0].getBoundingClientRect();
            var rightEdge = dimensions.width + dimensions.left;
            var screenWidth = $(window).width();
            
            if( $parent.hasClass('has-description') ) {
                
                var parentDimensions = $parent[0].getBoundingClientRect();
                newLeft = dimensions.width / 2 - parentDimensions.width / 2;
                var overRightEdge = rightEdge - newLeft - screenWidth;
                var overLeftEdge = ( dimensions.left - newLeft ) * -1;
                
                if( overRightEdge > 0 ) {
                    newLeft += overRightEdge;
                }
                else if( overLeftEdge > 0 ) {
                    newLeft -= overLeftEdge;
                }
                
            }
            else {
                
                var overRightEdge = rightEdge - screenWidth;
                
                if( overRightEdge > 0 ) {
                    newLeft = overRightEdge;
                }
                
            }
            
            $submenu.css('left', '-' + newLeft + 'px');
            
        }, 1);
        
    });
    
    $('.wp-block-navigation .has-child').on('mouseleave', function() {
        $(this).find('.wp-block-navigation__submenu-container').css('transform', 'initial');
    });
    
})(jQuery);